import axios from "axios";
const API_URL = `${process.env.REACT_APP_STRAPI_URL}/api`;

// Obtener videos institucionales de la ruta /api/misim-videos
export const getMisimVideos = async () => {
  try {
    const response = await axios.get(`${API_URL}/misim-videos?populate=*`);
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo misim-videos:", error);
    return [];
  }
};

// Home Bloqus
export const getHomeBloqus = async () => {
  try {
    const response = await axios.get(`${API_URL}/home-bloqus?populate=*`);
    return response.data;
  } catch (error) {
    console.error("Error obteniendo home-bloqus:", error);
    return [];
  }
};

// Homes
export const getHomes = async () => {
  try {
    const response = await axios.get(
      `${API_URL}/homes?populate[beneficio][populate]=*`
    );
    return response.data;
  } catch (error) {
    console.error("Error obteniendo homes:", error);
    return [];
  }
};

export const getHomeCarousel = async () => {
  try {
    const response = await axios.get(`${API_URL}/home-carousels?populate=*&sort=order:asc`);
    return response.data;
  } catch (error) {
    console.error("Error obteniendo home-carousels:", error);
    return [];
  }
};
// Home Bloque1s
export const getHomeBloque1s = async () => {
  try {
    const response = await axios.get(`${API_URL}/home-bloque1s?populate=*`);
    return response.data;
  } catch (error) {
    console.error("Error obteniendo home-bloque1s:", error);
    return [];
  }
};

// Home Bloque2s
export const getHomeBloque2s = async () => {
  try {
    const response = await axios.get(`${API_URL}/home-bloque2s?populate=*`);
    return response.data;
  } catch (error) {
    console.error("Error obteniendo home-bloque2s:", error);
    return [];
  }
};

/**
 * Obtiene las novedades desde Strapi
 * @returns {Promise<Array>} Array de novedades con sus imágenes
 * populate[img][populate]=img - Poblar las imágenes anidadas
 * populate=imagen - Poblar el campo imagen principal
 */
export const getNovedades = async () => {
  try {
    const response = await axios.get(
      `${API_URL}/novedades?populate[imagen]=true&populate[video]=true&populate[img][populate]=img`
    );
    return response.data;
  } catch (error) {
    console.error("Error obteniendo novedades:", error);
    return []; // Retorna array vacío en caso de error
  }
};

export const getEventos = async () => {
  try {
    const response = await axios.get(
      `${API_URL}/eventos?populate[imagen]=true&populate[video]=true&populate[img][populate]=img`
    );
    return response.data;
  } catch (error) {
    console.error("Error obteniendo eventos:", error);
    return [];
  }
};

/**
 * Obtiene todos los testimonios con sus relaciones
 * populate=* - Poblar todas las relaciones del modelo
 * @returns {Promise<Array>} Array de testimonios
 */
export const getTestimonioById = async () => {
  try {
    const response = await axios.get(`${API_URL}/testimonios?populate=*`);
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo testimonio por id:", error);
    return null;
  }
};

/**
 * Obtiene los testimonios de marcas
 * No requiere populate ya que solo necesitamos datos básicos
 * @returns {Promise<Array>} Array de testimonios de marcas
 */
export const getTestimonioMarcas = async () => {
  try {
    const response = await axios.get(`${API_URL}/testimonio-marcas`);
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo marca:", error);
    return null;
  }
};
export const getTestimonioUSer = async () => {
  try {
    const response = await axios.get(`${API_URL}/testimonios-users?populate=*`);

    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo user", error);
    return null;
  }
};
export const getClientes = async () => {
  try {
    const response = await axios.get(
      `${API_URL}/clientes?populate=*&pagination[page]=1&pagination[pageSize]=100`
    );

    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo clientes:", error);
    return null;
  }
};
/**
 *  Obtiene los datos de Hero de la página principal
 * populate=* - Poblar todas las relaciones (imágenes, videos, etc.)
 * @returns {Promise<Array>} Array de héroes de la página principal
 */
export const getHomeHero = async () => {
  try {
    const response = await axios.get(`${API_URL}/home-heroes?populate=*`);
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo héroes de home:", error);
    return null;
  }
};

/**
 * Obtiene los datos de Hero de insurance
 * populate=* - Poblar todas las relaciones (imágenes, contenido)
 * @returns {Promise<Array>} Array de héroes de seguros
 */
export const getHeroInsurances = async () => {
  try {
    const response = await axios.get(`${API_URL}/hero-insurances?populate=*`);
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo héroes de seguros:", error);
    return null;
  }
};
export const getHeroComex = async () => {
  try {
    const response = await axios.get(`${API_URL}/hero-comexes?populate=*`);

    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo heroBox:", error);
    return null;
  }
};
/**
 * Obtiene los Beneficios Comex
 * populate=* - Poblar todas las relaciones (imágenes, contenido)
 * @returns {Promise<Array>} Array de héroes de seguros
 */
export const getBeneficiosComex = async () => {
  try {
    const response = await axios.get(
      `${API_URL}/beneficios-comexes?populate=*`
    );
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo beneficios-comexes:", error);
    return null;
  }
};

export const getAutomotrizComex = async () => {
  try {
    const response = await axios.get(
      `${API_URL}/automotriz-comexes?populate=*`
    );
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo automotriz-comexes:", error);
    return null;
  }
};

export const getContactoComex = async () => {
  try {
    const response = await axios.get(`${API_URL}/contacto-comexes?populate=*`);
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo contacto-comexes:", error);
    return null;
  }
};

export const getMarcasComex = async () => {
  try {
    const response = await axios.get(`${API_URL}/marcas-comexes?populate=*`);
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo marcas-comexes:", error);
    return null;
  }
};

export const getTestimonioComex = async () => {
  try {
    const response = await axios.get(
      `${API_URL}/testimonio-comexes?populate=*`
    );
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo testimonio-comexes:", error);
    return null;
  }
};

export const getVideoComex = async () => {
  try {
    const response = await axios.get(`${API_URL}/video-comexes?populate=*`);
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo video-comexes:", error);
    return null;
  }
};
export const getCertificaciones = async () => {
  try {
    const response = await axios.get(`${API_URL}/certificaciones?populate=*`);
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo video-comexes:", error);
    return null;
  }
};
export const getContactosHeroes = async () => {
  try {
    const response = await axios.get(`${API_URL}/contactos-heroes?populate=*`);

    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo contactos-heroes:", error);
    return null;
  }
};

export const getMreHeroes = async () => {
  try {
    const response = await axios.get(`${API_URL}/mre-heroes?populate=*`);
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo mre-heroes:", error);
    return null;
  }
};

export const getNosotrosHeroes = async () => {
  try {
    const response = await axios.get(`${API_URL}/nosotros-heroes?populate=*`);
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo nosotros-heroes:", error);
    return null;
  }
};

export const getNosotrosTeams = async () => {
  try {
    const response = await axios.get(`${API_URL}/nosotros-teams?populate=*`);
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo nosotros-teams:", error);
    return null;
  }
};

export const getPayHeroes = async () => {
  try {
    const response = await axios.get(`${API_URL}/pay-heroes?populate=*`);
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo pay-heroes:", error);
    return null;
  }
};

export const getSmartReaderHeroes = async () => {
  try {
    const response = await axios.get(
      `${API_URL}/smart-reader-heroes?populate=*`
    );
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo smart-reader-heroes:", error);
    return null;
  }
};

export const getMisimHeroes = async () => {
  try {
    const response = await axios.get(`${API_URL}/misim-heroes?populate=*`);
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo misim-heroes:", error);
    return null;
  }
};

export const getMisimTestimonios = async () => {
  try {
    const response = await axios.get(`${API_URL}/misim-testimonios?populate=*`);
    return response.data;
  } catch (error) {
    console.error("Error obteniendo misim-testimonios:", error);
    return [];
  }
};

export const getMisimClientes = async () => {
  try {
    const response = await axios.get(`${API_URL}/misim-clientes?populate=*`);
    return response.data;
  } catch (error) {
    console.error("Error obteniendo misim-clientes:", error);
    return [];
  }
};

export const getEventoHeroes = async () => {
  try {
    const response = await axios.get(`${API_URL}/evento-heroes?populate=*`);
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo evento-heroes:", error);
    return null;
  }
};

export const getBlogHeroes = async () => {
  try {
    const response = await axios.get(`${API_URL}/blog-heroes?populate=*`);
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo blog-heroes:", error);
    return null;
  }
};

export const getKitPartnes = async () => {
  try {
    const response = await axios.get(`${API_URL}/kit-partnes?populate=*`);
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo kit-partnes:", error);
    return null;
  }
};

export const getComercios = async () => {
  try {
    const response = await axios.get(`${API_URL}/comercios?populate=*`);
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo comercios:", error);
    return null;
  }
};

export const getVentas = async () => {
  try {
    const response = await axios.get(`${API_URL}/ventas?populate=*`);
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo ventas:", error);
    return null;
  }
};

/**
 * Obtiene la metadata SEO para la página de eventos
 * populate=* - Poblar todas las relaciones (metatags, imágenes)
 * @returns {Promise<Array>} Metadata SEO de eventos
 */
export const getSeoEventos = async () => {
  try {
    const response = await axios.get(`${API_URL}/seo-eventos?populate=*`);
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo seo-eventos:", error);
    return null;
  }
};

export const getSeoHomes = async () => {
  try {
    const response = await axios.get(`${API_URL}/seo-homes?populate=*`);
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo seo-homes:", error);
    return null;
  }
};

export const getSeoInsurances = async () => {
  try {
    const response = await axios.get(`${API_URL}/seo-insurances?populate=*`);
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo seo-insurances:", error);
    return null;
  }
};

export const getSeoMisims = async () => {
  try {
    const response = await axios.get(`${API_URL}/seo-misims?populate=*`);
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo seo-misims:", error);
    return null;
  }
};

export const getSeoMres = async () => {
  try {
    const response = await axios.get(`${API_URL}/seo-mres?populate=*`);
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo seo-mres:", error);
    return null;
  }
};

export const getSeoNosotros = async () => {
  try {
    const response = await axios.get(`${API_URL}/seo-nosotros?populate=*`);
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo seo-nosotros:", error);
    return null;
  }
};

export const getSeoNovedades = async () => {
  try {
    const response = await axios.get(`${API_URL}/seo-novedades?populate=*`);
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo seo-novedades:", error);
    return null;
  }
};

export const getSeoPays = async () => {
  try {
    const response = await axios.get(`${API_URL}/seo-pays?populate=*`);
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo seo-pays:", error);
    return null;
  }
};

export const getSeoSmartReaders = async () => {
  try {
    const response = await axios.get(`${API_URL}/seo-smart-readers?populate=*`);
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo seo-smart-readers:", error);
    return null;
  }
};

/**
 * Obtiene las tarjetas de información MRE
 * populate=* - Poblar todas las relaciones (imágenes, iconos)
 * Usa la URL base directamente para mantener consistencia con la estructura
 * @returns {Promise<Object>} Datos de las tarjetas MRE
 */
export const getMreCardsService = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_STRAPI_URL}/api/card-mres?populate=*`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching MRE cards:", error);
    return []; // Retorna array vacío en caso de error
  }
};

/**
 * Obtiene los videos de MRE
 * @returns {Promise<Array>} Array de videos MRE
 */
export const getMreVideos = async () => {
  try {
    const response = await axios.get(`${API_URL}/mre-videos?populate=*`);

    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo mre-videos:", error);
    return null;
  }
};

/**
 * Obtiene los videos de la página principal (Home)
 * @returns {Promise<Array>} Array de videos para la sección Home
 */
export const getHomeVideos = async () => {
  try {
    const response = await axios.get(`${API_URL}/home-videos?populate=*`);
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo home-videos:", error);
    return null;
  }
};

/**
 * Obtiene los datos de Smart Readers
 * @returns {Promise<Array>} Array de smart readers
 */
export const getSmartReaders = async () => {
  try {
    const response = await axios.get(`${API_URL}/smart-readers?populate=*`);
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo smart-readers:", error);
    return null;
  }
};

export const getPWCCategories = async () => {
  try {
    const response = await axios.get(`${API_URL}/pwc-categories`);
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo pwc-categories:", error);
    return null;
  }
}

// Busca preguntas con filtros y paginado en Strapi
export const searchPWCPreguntas = async ({ q, categoriaId, page = 1, pageSize = 8 } = {}) => {
  try {
    const params = new URLSearchParams();
    // filtros de texto (a partir de 3 caracteres)
    if (q && q.trim().length >= 3) {
      const val = q.trim();
      params.set("filters[$or][0][Pregunta][$containsi]", val);
      params.set("filters[$or][1][RespuestaCorta][$containsi]", val);
      params.set("filters[$or][2][Respuesta][$containsi]", val);
    }
    // filtro por categoría (relación)
    if (categoriaId) {
      params.set("filters[pwc_category][id][$eq]", String(categoriaId));
    }
    // paginación
    params.set("pagination[page]", String(page));
    params.set("pagination[pageSize]", String(pageSize));

    const response = await axios.get(`${API_URL}/pwc-questions?${params.toString()}`);
    return response.data; // incluye data y meta
  } catch (error) {
    console.error("Error buscando pwc-questions:", error);
    return { data: [], meta: { pagination: { page: 1, pageSize: 8, pageCount: 1, total: 0 } } };
  }
};

// Obtiene una pregunta por ID (fetchOne)
export const getPWCPreguntaById = async (id) => {
  try {
    if (!id) return null;
    const res = await axios.get(
      `${API_URL}/pwc-questions/${id}?populate[pwc_expert][populate][0]=Foto`
    );
    return res.data?.data || null;
  } catch (error) {
    console.error("Error obteniendo pwc-questions por id:", error);
    return null;
  }
};

//Contacto agendas
export const getContactoAgenda = async () => {
  try {
    const response = await axios.get(
      `${API_URL}/contactos-agendas?populate=*&sort=orden:asc`
    );
    return response.data.data;
  } catch (error) {
    console.error("Error obteniendo contactos-agendas:", error);
    return null;
  }
};


// Bitácoras
// export const createBitacora = async (data) => {
//   try {
//     const jwt = localStorage.getItem("jwt");
//     const headers = jwt ? { Authorization: `Bearer ${jwt}` } : {};
//     const response = await axios.post(
//       `${API_URL}/bitacoras`,
//       { data },
//       { headers }
//     );
//     console.log("Bitácora creada:", response.data);
//     return response.data;
//   } catch (error) {
//     console.error("Error creando bitácora:", error);
//     throw error;
//   }
// };

// export const updateBitacora = async (id, data) => {
//   try {
//     const jwt = localStorage.getItem("jwt");
//     const headers = jwt ? { Authorization: `Bearer ${jwt}` } : {};
//     const response = await axios.put(
//       `${API_URL}/bitacoras/${id}`,
//       { data },
//       { headers }
//     );
//     return response.data;
//   } catch (error) {
//     console.error("Error actualizando bitácora:", error);
//     throw error;
//   }
// };

// export const deleteBitacora = async (id) => {
//   try {
//     const jwt = localStorage.getItem("jwt");
//     const headers = jwt ? { Authorization: `Bearer ${jwt}` } : {};
//     const response = await axios.delete(`${API_URL}/bitacoras/${id}`, {
//       headers,
//     });
//     return response.data;
//   } catch (error) {
//     console.error("Error eliminando bitácora:", error);
//     throw error;
//   }
// };
